import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import {
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  Form,
  Image,
  Input,
  Row,
  Typography,
} from "antd";
import { useAppDispatch } from "hooks/reduxHooks";
import { notificationController } from "controllers/notificationController";
import { doLogin } from "store/slices/authSlice";
import "./LoginForm.css";
import SSOLogin from "./SSOGoogle";
import SSOMicrosoftLogin from "./SSOMicrosoft";

interface LoginFormData {
  email: string;
  password: string;
}

export const LoginForm: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [isLoading, setLoading] = useState(false);

  const handleSubmit = (values: LoginFormData) => {
    setLoading(true);
    dispatch(doLogin(values))
      .unwrap()
      .then((data) => {
        navigate("/");
      })
      .catch((err) => {
        notificationController.error({
          message: "Invalid email or password.",
        });
        setLoading(false);
      });
  };

  return (
    <>
      <Row
        justify="center"
        align="middle"
        style={{ minHeight: "100vh" }}
        className="login-back"
      >
        <Col span={24}>
          <div className="login-logo-wrapper">
            <Image
              className="login-card"
              style={{ margin: "auto", width: "200px" }}
              src="/sinecure-logo.png"
              preview={false}
            />
          </div>
          <Card className="login-card" style={{ margin: "auto" }}>
            <Typography.Title
              level={3}
              style={{
                textAlign: "center",
                marginBottom: "30px",
                color: "#002766",
              }}
            >
              Sign in to Sinecure
            </Typography.Title>
            <Form
              layout="vertical"
              name="basic"
              initialValues={{ remember: true }}
              onFinish={handleSubmit}
              autoComplete="off"
            >
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Please input your email!" },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Password"
                name="password"
                className="password"
                rules={[
                  { required: true, message: "Please input your password!" },
                ]}
              >
                <Input.Password />
              </Form.Item>

              <Form.Item wrapperCol={{ span: 24 }} className="mt-30 mb-0 ">
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  className="w-100"
                >
                  Submit
                </Button>
              </Form.Item>
              <Divider>OR</Divider>
              <SSOLogin></SSOLogin>
              <SSOMicrosoftLogin></SSOMicrosoftLogin>
            </Form>
          </Card>
        </Col>
      </Row>
      <Row justify="center" style={{ marginTop: "10px" }}>
        <Col>
          <a href="https://sinecure.ai/privacy-policy/">Privacy Policy</a>
        </Col>
      </Row>
    </>
  );
};
